import PropTypes from 'prop-types';
import Translation from '../../../lang/Translation';
import useStyles from './BasketItemImageV2.styles';

function BasketItemImageV2(props) {
  const classes = useStyles({...props});
  
  return (
    <span className={classes.basketItemImage} data-test="BasketItemImageV2">
      <span className={classes.imageContainer}>
        <img
          className={classes.image}
          data-test="BasketItemImage__image"
          alt=""
          src={`https://${props.productUrl}`}
          title={props.title}
        />
        {props.additionalItems > 0 && props.isLastDisplayableItem && (
          <span className={classes.additionalItems} data-test="BasketItemImage__additionalItems">
            <span className={classes.moreItemsText}>
              <Translation placeholderValues={[props.additionalItems]}>
                orderSummary.more.items
              </Translation>
            </span>
          </span>
        )}
        {props.quantity > 1 && (
          <span className={classes.quantity} data-test="BasketItemImage__badge" aria-hidden="true">
            {props.quantity}
          </span>
        )}
      </span>
    </span>
  );
}

BasketItemImageV2.defaultProps = {
  additionalItems: 0,
  isLastDisplayableItem: false,
  mergedGroupsEnabled: false,
};

BasketItemImageV2.propTypes = {
  productUrl: PropTypes.string.isRequired,
  quantity: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  additionalItems: PropTypes.number,
  isLastDisplayableItem: PropTypes.bool,
  mergedGroupsEnabled: PropTypes.bool,
};

export default BasketItemImageV2;
